import React, { useMemo } from 'react';

import { Guid } from '../../../../store/model/guid';
import { getItemByIdSelector } from '../../../../store/reducers/items/itemsSelectors';
import { useStudentSelector } from '../../../../store/selectors/useStudentSelector';
import { createCompletionServiceSelector } from '../../services/CompletionService';
import { TrackingStatus } from '@ael/core-api';

type RenderCallback = (trackingStatus: TrackingStatus) => React.ReactElement;

interface ExternalProps {
  itemId: Guid;
  render: RenderCallback;
}

export const TrackingStatusProvider: React.FC<ExternalProps> = ({ itemId, render }) => {
  // Get item by id only once per itemId change
  const item = useStudentSelector((state) => {
    const getItemById = getItemByIdSelector(state);
    return getItemById(itemId);
  });

  // Get evaluator service - should be memoized by reselect
  const evaluator = useStudentSelector(createCompletionServiceSelector);

  // Memoize the evaluation result to prevent recalculations
  const trackingStatus = useMemo(() => {
    return evaluator.evaluate(item);
  }, [evaluator, item]);

  // Render with the memoized result
  return render(trackingStatus);
};

TrackingStatusProvider.displayName = 'TrackingStatusProvider';
